<template>
  <TWModal
    :title="$t('envelope.cancelReminders')"
    :show="show"
    :autoFocus="false"
    :loading="loading"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <p>{{ $t('envelope.cancelRemindersWarning') }}</p>
    </template>

    <template v-slot:controls>
      <BaseButton
        variant="invisible"
        @click.native="handleGoBack"
        data-ec="cancel_reminders_modal"
        data-et="actually_never_mind_button"
      >
        {{ $t('functional.actuallyNoThanks') }}
      </BaseButton>

      <BaseButton
        @click.native="cancelReminders"
        variant="danger"
        data-ec="cancel_reminders_modal"
        data-et="cancel_reminders_button"
      >
        {{ $t('envelope.confirmCancelNow') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'RemindersCancelModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    envelope: {
      type: [Object],
      required: true,
    },
    setReminders: {
      type: [Object],
      required: true,
    },
    creating: {
      type: [Boolean],
      default: false,
    },
  },
  components: {
    TWModal,
    BaseButton,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    reminders() {
      return this.setReminders;
    },
  },
  methods: {
    handleGoBack() {
      this.$emit('close');
      this.$emit('openSetRemindersModal');
    },
    async cancelReminders() {
      this.loading = true;
      this.reminders.fingerprint = this.envelope.fingerprint;
      this.reminders.days = 0;
      await this.$store.dispatch('envelopes/CANCEL_ENVELOPE_REMINDERS', { reminders: this.reminders, isCreating: this.creating }).then((response) => {
        if (response) {
          this.$emit('close');
          this.$bus.$emit('renderGlobalMessage', ({
            message: this.$t('message.success.removed', { name: 'reminders' }),
            icon: 'check',
            type: 'success',
          }));
          this.loading = false;
        }
      });
    },
  },
};
</script>
